import * as Yup from 'yup'
import dayjs from 'dayjs'
import { MedicalCardRequirement } from 'src/constants/collect-data/enums'

Yup.addMethod(Yup.string, 'validateDate', function (errorMessage) {
  return this.test(`test-date`, errorMessage, function (value) {
    const { path, createError } = this

    if (!value) {
      return createError({ path, message: errorMessage })
    }

    const date = dayjs(value, 'MM/DD/YYYY', true)

    if (!date.isValid()) {
      return createError({ path, message: 'Date must be in MM/DD/YYYY format' })
    }

    if (date.isAfter(dayjs())) {
      return createError({ path, message: 'Date cannot be in the future' })
    }

    return true
  })
})

const baseSchema = (medicalCardRequirement: MedicalCardRequirement) => ({
  lastSubmittedAt: Yup.string()
    .required('Last submitted date is required')
    // @ts-ignore
    .validateDate('Last submitted date is invalid'),
  file:
    medicalCardRequirement === MedicalCardRequirement.Required
      ? Yup.mixed().required('DOT document is required')
      : Yup.mixed(),
})

export const getDOTNumberSchema = (medicalCardRequirement: MedicalCardRequirement) =>
  Yup.object().shape({
    ...baseSchema(medicalCardRequirement),
    dotNumber: Yup.string().required('DOT Number is required'),
    stateOfIssue: Yup.string().required('State of Issue is required'),
  })

export const getUSDOTNumberSchema = (medicalCardRequirement: MedicalCardRequirement) =>
  Yup.object().shape({
    ...baseSchema(medicalCardRequirement),
    usDotNumber: Yup.string().required('USDOT Number is required'),
  })
